export default __webpack_public_path__ + "static/media/peaceIcon.c64aef38.svg";